import http from 'utils/http'

const fetchingMenu = (idBusiness, idAddress) =>
  http.get(`/menu/v1/menu/business/${idBusiness}/address/${idAddress}`)

const getListAddressToDelivery = payload =>
  http.post('/user/v1/business/addresses-to-delivery', payload)

// const getRecentlyOrdered = () => http.get('/order/v1/order/lastorders/')
const getRecentlyOrdered = idAddress => http.get(`/order/v1/order/lastorders/address/${idAddress}`)

const getProducts = (idRestaurant, idCategory, idProduct = 0) =>
  http.get(`/menu/v1/product/${idProduct}/categoryType/${idCategory}/restaurant/${idRestaurant}`)

const getCategoryFromProduct = (product, idRestaurant) =>
  http.get(
    `/menu/v1/product/${product.id}/categoryType/${product.idCategoryType}/restaurant/${idRestaurant}`,
  )

const verifyRestaurantAvailable = (idRestaurant, idBusiness) =>
http.get(`/menu/v1/restaurant/available/business/${idBusiness}/restaurant/${idRestaurant}`)

const logout = () => http.get('/user/v1/logout')

export default {
  fetchingMenu,
  getListAddressToDelivery,
  getRecentlyOrdered,
  getProducts,
  getCategoryFromProduct,
  logout,
  verifyRestaurantAvailable
}



// WEBPACK FOOTER //
// ./src/services/menuService.js